// extracted by mini-css-extract-plugin
module.exports = {"button":"C6ULpGG0"};